import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../ui/accordion";

const FAQS = [
  { q: "Is candidate resume data kept private?", a: "Yes. Resumes are only used to generate the evaluation for your workspace and are never used to train AI models or shared with other tenants." },
  { q: "How accurate is hireqix's scoring?", a: "Every score is evidence-based — the system is instructed to never assume or fabricate experience. If information is missing, it explicitly flags insufficient evidence instead of guessing." },
  { q: "How does multi-batch evaluation work?", a: "Every time you upload a new set of resumes to an existing job, hireqix creates a new collapsible batch table (Batch 2, Batch 3...) without touching previously scored candidates." },
  { q: "Do credits expire?", a: "No, purchased credits never expire. Each resume evaluation costs 2 credits, and top-ups start at ₹500." },
  { q: "Can I customize the scoring criteria per job?", a: "Yes — every job has its own competency matrix with custom names and weights that must total 100%, plus optional evaluation instructions." },
];

export default function LandingFAQ() {
  return (
    <section id="faq" className="px-4 py-20 sm:px-6 sm:py-28 lg:px-8">
      <div className="mx-auto max-w-3xl">
        <div className="text-center">
          <span className="text-xs font-bold uppercase tracking-widest text-primary">FAQ</span>
          <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">Frequently asked questions</h2>
        </div>

        <Accordion type="single" collapsible className="mt-10 space-y-3" data-testid="landing-faq-accordion">
          {FAQS.map((f, idx) => (
            <AccordionItem
              key={idx}
              value={`faq-${idx}`}
              data-testid={`landing-faq-item-${idx}`}
              className="rounded-2xl border border-border/70 bg-card px-5 shadow-sm transition-all duration-300 hover:shadow-md glossy-card glossy-sheen"
            >
              <AccordionTrigger className="font-heading text-base">{f.q}</AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-muted-foreground">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
